import React from 'react';
import { defineMessages, useIntl } from 'react-intl';
import { Bar, Chart } from 'react-chartjs-2';
import PropTypes from 'prop-types';

const i18n = defineMessages({
  newStatus: {
    id: 'candidate.status.NEW',
    defaultMessage: 'New',
  },
  invitedStatus: {
    id: 'candidate.status.INVITED',
    defaultMessage: 'Invited',
  },
  declinedStatus: {
    id: 'candidate.status.DECLINED',
    defaultMessage: 'declined',
  },
  startedStatus: {
    id: 'candidate.status.STARTED',
    defaultMessage: 'In progress',
  },
  submittedStatus: {
    id: 'candidate.status.SUBMITTED',
    defaultMessage: 'Assessed',
  },
  expiredStatus: {
    id: 'candidate.status.EXPIRED',
    defaultMessage: 'Expired',
  },
});

const AssessmentsBar = ({ assessmentsByStatus }) => {
  const { formatMessage } = useIntl();

  const dataLable = [
    formatMessage(i18n.newStatus).toUpperCase(),
    formatMessage(i18n.invitedStatus).toUpperCase(),
    formatMessage(i18n.declinedStatus).toUpperCase(),
    formatMessage(i18n.startedStatus).toUpperCase(),
    formatMessage(i18n.submittedStatus).toUpperCase(),
    formatMessage(i18n.expiredStatus).toUpperCase(),
  ];
  const colorbackground = ['#78909b', '#41c6d8', '#f96b48', '#fcc136', '#92c157', 'rgba(255, 159, 64, 0.2)'];
  const dataAssessments = [
    assessmentsByStatus.NEW,
    assessmentsByStatus.INVITED,
    assessmentsByStatus.DECLINED,
    assessmentsByStatus.STARTED,
    assessmentsByStatus.SUBMITTED,
    assessmentsByStatus.EXPIRED,
  ];
  const data = {
    labels: dataLable,
    datasets: [
      {
        backgroundColor: colorbackground,
        borderWidth: 1,
        hoverBorderColor: 'rgba(255,99,132,1)',
        data: dataAssessments,
      },
    ],
  };

  const options = {
    layout: {
      padding: 25,
    },
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true,
            userCallback(label) {
              if (Math.floor(label) === label) {
                return label;
              }
              return null;
            },
          },
        },
      ],
    },
    events: false,
    maintainAspectRatio: true,
    legend: { display: false },
    showAllTooltips: false,
    animation: {
      duration: 0,
      onComplete() {
        // eslint-disable-next-line react/no-this-in-sfc
        const { ctx } = this.chart;
        ctx.font = Chart.helpers.fontString(
          Chart.defaults.global.defaultFontFamily,
          'normal',
          Chart.defaults.global.defaultFontFamily,
        );
        ctx.fillStyle = 'black';
        ctx.textAlign = 'center';
        ctx.textBaseline = 'bottom';
        data.datasets.forEach((dataset) => {
          for (let i = 0; i < dataset.data.length; i += 1) {
            for (const key in dataset._meta) {
              if (dataset._meta[key]) {
                const model = dataset._meta[key].data[i]._model;
                ctx.fillText(dataset.data[i], model.x, model.y + 1);
              }
            }
          }
        });
      },
    },
  };

  return (
    <div>
      <Bar data={data} width={100} height={70} options={options} />{' '}
    </div>
  );
};

AssessmentsBar.propTypes = {
  assessmentsByStatus: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default AssessmentsBar;
